module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/18a6f5c4865e6af60206964b724ad3bd.png";